<template>
  <div class="layout">
    <m-header
      v-if="logined"
      :title="schoolName"
      :left-options="{ preventGoBack: true }"
      :show-left="false"
      :isShowArrow="true"
      @on-click-title="exchangeSchool"
      @on-click-back="goBack"
    >
      <img class="changeUser" alt slot="right" src="@/assets/changeUser.png" @click="loginOut" />
    </m-header>
    <!-- <div class="content" style="padding-top: 10px;"> -->
    <div class="content">
      <div class="scroll-list-wrap" :style="{ height: wrapHeight + 'px' }">
        <cube-scroll
          v-if="list !== null && list.length === 0"
          ref="scroll"
          :options="noDataOptions"
          @pulling-down="onPullingDown"
        >
          <!-- 只有下拉刷新 -->
          <m-no-data type="live" text="没有找到直播" @addHandle="addHandle" />
        </cube-scroll>
        <cube-scroll
          v-else
          ref="scroll"
          :data="list"
          :options="options"
          @pulling-down="onPullingDown"
          @pulling-up="onPullingUp"
        >
          <!-- <div v-if="list !== null && list.length > 0">
            <live-list-item-code
              v-for="item in list"
              :key="item.id"
              :live="item"
              @delLive="delLive"
              @start-live="startLive"
            />
          </div> -->
          <div class="live-status" v-if="livingList !== null && livingList.length > 0">
            <img src="../../../assets/living-icon.gif" />直播中
          </div>
          <div v-if="livingList !== null && livingList.length > 0">
            <live-list-item-code
              v-for="item in livingList"
              :key="item.id"
              :live="item"
              :deviceUuid="deviceUuid"
              @delLive="delLive"
              @start-live="startLive"
            />
          </div>
          <div class="live-status" v-if="liveList !== null && liveList.length > 0">
            <img src="../../../assets/live-icon.gif" />未开始
          </div>
          <div v-if="liveList !== null && liveList.length > 0">
            <live-list-item-code
              v-for="item in liveList"
              :key="item.id"
              :live="item"
              :deviceUuid="deviceUuid"
              @delLive="delLive"
              @start-live="startLive"
            />
          </div>
        </cube-scroll>
      </div>
    </div>
    <!-- <m-suspend-button v-if="liveAuth" text="创建" @onSuspendBtnClick="addHandle"> -->
    <m-suspend-button v-if="liveAuth && list && list.length > 0" text="" @onSuspendBtnClick="addHandle">
      <img alt src="@/assets/yuyue0.png" slot="icon" />
    </m-suspend-button>
    <loading v-if="isLoading" />
    <share-login ref="popup" :isShowLogin="true" @changeShowLogin="changeShowLogin" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import MHeader from '@/components/MHeader/Index.vue';
// import MSearch from '@/components/MSearch/Index.vue';
import MNoData from '@/components/MNoData/IndexForLive.vue';
import api from '@/api/app';
import ShareLogin from '@/pages/ShareLogin/index.vue';
import liveApi from '@/api/live';
import scrollMixin from '@/mixins/scroll';
import backMixin from '@/mixins/back';
import loadingMixin from '@/mixins/loading';
import LiveListItemCode from '@/components/Live/ListItemCode.vue';
import MSuspendButton from '@/components/MSuspendButton/Index.vue';
import Loading from '@/components/Loading/Index.vue';
import Cookies from 'js-cookie';

export default {
  name: 'live-list-code',
  components: {
    MHeader,
    // MSearch,
    MNoData,
    MSuspendButton,
    LiveListItemCode,
    Loading,
    ShareLogin
  },
  props: {
    // 用于判断是否为分享后的视频页面引用
    isVisitor: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [scrollMixin, backMixin, loadingMixin],
  data() {
    return {
      page: 1,
      pageSize: 20,
      wrapHeight: 300,
      list: null,
      livingList: [],
      liveList: [],
      liveAuth: false, // 直播权限
      logined: true,
      deviceUuid: '',
      pcUuid: '',
      noDataOptions: {
        pullDownRefresh: {
          threshold: 60,
          stop: 40,
          txt: '更新完毕'
        },
        pullUpLoad: false
      }
    };
  },
  computed: {
    ...mapGetters(['schoolName', 'liveKeyword', 'schoolsArray'])
  },
  activated() {
    this.checkLogin();
    this.mobile = this.mobile ? this.mobile : localStorage.getItem('mobile');
    
    console.log('this.$route.meta.refresh', this.$route.meta.refresh);
    console.log('this.schoolName', this.schoolName);
    console.log('this.mobile', this.mobile);
    if (!this.mobile) {
      return;
    }
    if (this.$route.meta.refresh === null) {
      this.getUser();
      this.$route.meta.refresh = false;
      return;
    }
    console.log('this.$route.meta.refresh', this.$route.meta.refresh);
    console.log('this.schoolName', this.schoolName);
    if (this.$route.meta.refresh) {
      if (this.schoolName) {
        this.checkSchoolAuth();
        this.getLiveList();
      } else {
        this.getUser();
      }

      this.$route.meta.refresh = false;
    }
  },
  created() {},
  mounted() {
    this.wrapHeight = this.$calcWrapHeight();
    this.mobile = this.$route.query.mobile;
    this.changeLoadingStatus(true);

    this.deviceUuid = this.$route.query.deviceUuid ? this.$route.query.deviceUuid : '';

    this.pcUuid = this.$route.query.pcUuid ? this.$route.query.pcUuid : '';

    this.line_id = this.$route.query.line_id ? this.$route.query.line_id : '';

    if (!this.schoolName) {
      if (!this.mobile) {
        this.mobile = localStorage.getItem('mobile');
      }
    }
    this.checkLogin();
  },
  methods: {
    changeShowLogin(flag) {
      this.isShowLogin = flag;
    },
    getUser() {
      api
        .fetchUserInfo({
          mobile: this.mobile ? this.mobile : localStorage.getItem('mobile')
        })
        .then(response => {
          // if (response.result.success) {
          if (response.code === 0) {
            // this.$store.commit('SET_USER_INFO', response.result.data);//php后端
            this.$store.commit('SET_USER_INFO', response.result);
            // 直播，判断当前学校有无权限
            this.checkSchoolAuth();
            this.getLiveList();
            let userInfo = response.result;
            api
              .getUserSign({
                userId: userInfo.uid
              })
              .then(resSig => {
                console.log('res:getUserSign ', resSig);
                userInfo = { ...userInfo, ...resSig.result };
                global.localStorage.setItem('userInfo', JSON.stringify(userInfo));
                // window.localStorage['loginInfo'] = JSON.stringify(loginInfo);
                if (this.deviceUuid) {
                  // this.$store.commit('SET_USER_INFO', response.result.data);//php后端
                  this.$store.commit('SET_USER_INFO', userInfo);
                } else {
                  this.$store.commit('SET_VISITOR_INFO', userInfo);
                  global.localStorage.setItem('visitorInfo', JSON.stringify(userInfo));
                }
              });
          } else {
            Cookies.remove('vuex');
            this.changeLoadingStatus(false);
            this.$createToast({
              // txt: response.result.message || '该用户不存在',
              txt: response.other.msg || '该用户不存在',
              type: 'text'
            }).show();
          }
        })
        .catch(error => {
          console.log('getUserInfo error = ', error);
        });
    },
    // 获取未开始、直播中的列表
    getLiveList(key) {
      const page = this.page;
      const params = {
        page,
        pageSize: this.pageSize,
        search: this.liveKeyword,
        userPhone: this.mobile,
        schoolName: this.schoolName,
        flag: 'device',
        liveType: this.deviceUui && this.deviceUuid !== '' ? '4' : '5'
      };
      liveApi.fetchLiveListToCode(params).then(response => {
        if (response.code === 0) {
          const data = response.result.data;
          if (page > 1) {
            this.list = this.list.concat(data);
          } else {
            this.list = data;
            // if (data.length === 0) {
            //   // 无数据
            //   console.log('无数据');
            //   this.changeLoadingStatus(false);
            //   return;
            // }
          }
          // this.liveListGroup(this.list, key);
          this.liveListGroup(data, key);

          if (data.length === 0) {
            // 如果没有新数据
            this.$refs.scroll.forceUpdate();
          }
        } else {
          this.$refs.scroll.forceUpdate();
        }
        this.changeLoadingStatus(false);
      });
    },
    liveListGroup(arr, isOnReachBottom) {
      let living = [];
      let live = [];

      for (let j = 0; j < arr.length; j += 1) {
        if (arr[j].liveStatus == 0) {
          living.push(arr[j]);
        } else if (arr[j].liveStatus == 1) {
          live.push(arr[j]);
        }
      }

      // 是否是上滑加载数据
      if (isOnReachBottom === 'onPullingUp') {
        // 直播中
        this.livingList = this.livingList.concat(living);
        // 未开始
        this.liveList = this.liveList.concat(live);
      } else {
        // 正常获取直播列表
        this.livingList = living;
        this.liveList = live;
      }
    },
    loginOut() {
      // this.mobile = localStorage.getItem('mobile');
      this.$createDialog({
        type: 'confirm',
        icon: 'cubeic-alert',
        // title: '提示',
        content: '要切换用户登录吗',
        confirmBtn: {
          text: '确定',
          active: true
        },
        cancelBtn: {
          text: '取消',
          active: false
        },
        onConfirm: () => {
          // localStorage.removeItem('userInfo');
          // localStorage.removeItem('visitorInfo');
          // console.log('===', this.$refs.popup);
          this.$refs.popup.show(true);
        },
        onCancel: () => {}
      }).show();
    },
    exchangeSchool() {
      if (!this.schoolPicker) {
        this.schoolPicker = this.$createPicker({
          data: [this.schoolsArray],
          title: '切换学校',
          onSelect: selectedVal => {
            const name = selectedVal.join('');
            this.page = 1;
            this.list = [];
            this.$store.commit('SET_LIVE_SEARCH_KEYWORD', '');
            this.$store.commit('SET_SCHOOL_NAME', name);
            this.getLiveList();
            this.checkSchoolAuth();
          }
        });
      }
      this.schoolPicker.show();
    },
    onPullingDown() {
      this.page = 1;
      this.$store.commit('SET_LIVE_SEARCH_KEYWORD', '');
      this.getLiveList('onPullingDown');
    },
    onPullingUp() {
      this.page += 1;
      this.getLiveList('onPullingUp');
    },
    search(value) {
      this.page = 1;
      this.$store.commit('SET_LIVE_SEARCH_KEYWORD', value);
      this.getLiveList();
    },
    delLive(item) {
      liveApi
        .fetchLiveDelete({
          liveId: item.liveId
        })
        .then(response => {
          if (response.result === true) {
            this.$createToast({
              txt: '直播删除成功',
              type: 'correct'
            }).show();
            this.page = 1;
            this.getLiveList();
          } else {
            this.$createToast({
              txt: '直播删除失败',
              type: 'error'
            }).show();
          }
        });
    },
    startLive(item) {
      // loading
      this.changeLoadingStatus(true);
      const params = {
        uuid: this.deviceUuid, // url中参数
        pushStreamUrl: item.livePushUrl
      };
      if (this.line_id !== '') {
        params.line_id = this.line_id;
      }
      liveApi
        .startLive(params)
        .then(response => {
          if (response.result === true) {
            this.$createToast({
              txt: '直播开启成功',
              type: 'correct'
            }).show();
            this.getLiveList();
          } else {
            this.$createToast({
              txt: '直播开启失败',
              type: 'error'
            }).show();
          }
          this.changeLoadingStatus(false);
        })
        .catch(error => {
          console.log('error: ', error);
          this.changeLoadingStatus(false);
        });
    },
    addHandle() {
      this.$router.push(`/addToCode?deviceUuid=${this.deviceUuid}&pcUuid=${this.pcUuid}&line_id=${this.line_id}`);
    },
    checkSchoolAuth() {
      // 去掉学校直播权限限制
      this.liveAuth = true;
      // liveApi.checkSchoolAuth({ schoolName: this.schoolName }).then(response => {
      //   if (response.code === 0) {
      //     this.liveAuth = response.result;
      //   } else {
      //     this.liveAuth = false;

      //     if (response.result === false) {
      //       this.$createToast({
      //         type: 'text',
      //         txt: `您所在学校“${this.schoolName}”没有开通直播权限`
      //       }).show();
      //     }
      //   }
      // });
    },
    checkLogin() {
      if (!window.localStorage) {
        alert('浏览器不支持localstorage');
      } else {
        const currentTime = new Date().getTime();
        const storage = window.localStorage;
        if (!storage.mobile || currentTime >= storage.outTime) {
          this.logined = false;
          window.localStorage['mobile'] = '';
          // 需要登录
          this.$refs.popup.show(false, this.deviceUuid);
          return;
        }
      }
    }
  }
};
</script>

<style lang="less" scope>
.layout {
  padding-bottom: 0 !important;
  .changeUser {
    width: 20px;
    height: 20px;
  }

  .live-status {
    padding: 8px;
    font-size: 14px;
    text-align: left;
    margin: 8px 0;
    display: flex;
    align-items: center;

    img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
  }
}
</style>
